module.exports = __webpack_public_path__ + "static/img/031树洞日记.f23f894.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/031树洞日记.jpg
// module id = WEGG
// module chunks = 0